/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useTheme } from '../../theme';
import { topLevelElementCss } from '.';
const Paragraph = React.forwardRef((props, ref) => {
    const theme = useTheme();
    return (jsx("div", Object.assign({}, props, { ref: ref, css: [
            topLevelElementCss,
            {
                color: theme.colors.paragraph.text,
                caretColor: theme.colors.paragraph.text,
            },
        ] })));
});
Paragraph.displayName = 'Paragraph';
export default React.memo(Paragraph);
//# sourceMappingURL=Paragraph.js.map